export const SET_AUTH = () => "SET_AUTH";
export const SET_EXPIRY = () => "SET_EXPIRY";
export const SET_USER = () => "SET_USER";
export const SET_ACTIVE_PORTFOLIO_TAB = () => "SET_ACTIVE_PORTFOLIO_TAB";
export const SET_TRAFFIC_DATA = () => "SET_TRAFFIC_DATA";
export const SET_TRAFFIC_DATE_YEAR = () => "SET_TRAFFIC_DATE_YEAR";
export const SET_TRAFFIC_DATE_MONTH = () => "SET_TRAFFIC_DATE_MONTH";
